


































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import {
  CreateUserGroupReq,
  RenameUserGroupReq,
  DeleteUserGroupReq,
} from "@/pbjs/external/auth/auth_pb";
import { errorMsg, handleResponse, setCommon } from "@/utils/request";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
@Component({})
export default class UserManagement extends Vue {
  @Provide() private input: string = "";
  @Provide() private tableData: any = [];
  @Prop() data!: any;
  @Prop() mainTitle!: any;
  @Prop() id!: any;
  @Prop() edit!: any;
  @Prop() search!: any;
  @Prop() isAddMainNode!: any;
  @Prop() item!: any;
  @Prop() defaultCheckKeys: any;
  @Prop() userGroupType: any;
  @Provide() compMainTitle: any = "";
  @Provide() compEdit: any = false;
  @Provide() tempId: number = 1000;
  @Provide() isNew: boolean = false;
  @Provide() isEdit: boolean = false;
  @Provide() private authorClient: any;
  @Provide() private counter: number = 0;
  @Provide() private token: string | null = "";
  @Provide() private compIsAddMainNode: boolean = false;
  @Provide() private compId: any;
  @Provide() private newDefaultCheckKeys: any;
  @Provide() private defaultProps: any = {
    children: "kidsList",
    label: "name",
    id: "id",
    index: "index",
    edit: "edit",
  };

  private created() {
    this.token = localStorage.getItem("token");
    this.compMainTitle = this.mainTitle;
    this.compEdit = this.edit;
    this.compIsAddMainNode = this.isAddMainNode;
    this.compId = this.id;
    this.isEdit = this.edit;
    this.newDefaultCheckKeys = this.defaultCheckKeys;
  }

  @Watch("defaultCheckKeys")
  onDefaultCheckKeysChanged(val: any) {
  }

  @Watch("search")
  onSearchChanged(val: string) {
    const ref: any = this.$refs.tree;
    ref.filter(val);
  }

  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }

  private append(data: any) {
    if (!this.isEdit) {
      const newChild = {
        id: this.tempId++,
        name: "",
        kidsList: [],
        edit: true,
        rolepid: data.id,
        ext: { exectype: data.ext.exectype },
      };
      if (!data.kidsList) {
        this.$set(data, "kidsList", []);
      }
      // this.input = "";
      this.isEdit = true;
      this.isNew = true;
      data.kidsList.push(newChild);
      this.newDefaultCheckKeys.push(data.id);

      setTimeout(() => {
        const ref: any = this.$refs[newChild.id];
        ref.focus();
      }, 0);
    }
  }

  private remove(node: any, data: any) {
    this.$confirm(this.$tc("authority.confirmDelete"), "", {
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    })
      .then(() => {
        this.deleteRoleAPI(node, data);
      })
      .catch(() => {
      });
  }

  private updateKeyChildren(node: any, data: any) {
    if (!this.isEdit) {
      this.isEdit = true;
      this.$set(data, "edit", true);
      this.$set(data, "label", data.name);
      this.$nextTick(() => {
        const ref: any = this.$refs[data.id];
        ref.focus();
      });
    }
  }

  private check(node: any, data: any) {
    // this.isEdit = false;
    // data.edit = true;
    // let newData = data;
    // newData.label = this.input;
    if (this.isNew) {
      if (data.label) {
        this.createUserGroup(data);
      } else {
        this.isEdit = false;
        this.$emit("returnRefreshTree", data.rolepid);
      }
    } else {
      this.updateRoleAPI(data);
    }
  }

  private close(node: any, data: any) {
    // this.isEdit = false;
    data.edit = false;
    if (this.isNew) {
      const parent = node.parent;
      const children = parent.data.kidsList || parent.data;
      const index = children.findIndex((d: any) => d.id === data.id);
      children.splice(index, 1);
    }
    this.isNew = false;
  }

  private appendMainNode() {
    // this.input = "";
    if (!this.isEdit) {
      this.isEdit = true;
      this.isNew = true;
      this.data.push({
        id: this.tempId++,
        label: "",
        edit: true,
        kidsList: [],
        rolepid: this.compId,
        ext: { exectype: this.item.ext.exectype },
      });
    }
  }

  private removeMainNode() {
    this.$confirm(this.$tc("authority.confirmDelete"), "", {
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    })
      .then(() => {
        this.deleteRoleAPI(null, { id: this.id });
      })
      .catch(() => {
      });
  }

  private createUserGroupFuc(responseData: any) {
    this.$emit("returnRefreshTree", responseData.usergroupid);
    this.$message({
      message: "创建成功",
      type: "success",
    });
    // const parent = node.parent;
    // const children = parent.data.children || parent.data;
    // const index = children.findIndex((d:any) => d.id === data.id);
    // data.id = responseData.roleid;
    // children.splice(index, 1, data);
    this.isNew = false;
  }
  private createUserGroup(item: any) {
    let request: any = new CreateUserGroupReq();
    request.setCommonin(setCommon());
    request.setParentusergroupid(item.rolepid);
    request.setName(item.label);
    if (item.ext.exectype === 1) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_INTERNAL);
    } else if (item.ext.exectype === 2) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_OUTSOURCE);
    } else if (item.ext.exectype === 3) {
      request.setExectype(ExecType.EXEC_TYPE_TEL_VERIFY);
    } else if (item.ext.exectype === 4) {
      request.setExectype(ExecType.EXEC_TYPE_ROBOT);
    }else if (item.ext.exectype === 6) {
      request.setExectype(ExecType.EXEC_TYPE_ADMIN);
    }else if (item.ext.exectype === 7) {
      request.setExectype(ExecType.EXEC_TYPE_PHONE_SALE);
    }

    authorClient.createUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let responseData: any = response.toObject();
        this.isEdit = false;
        let _fuc = this.createUserGroupFuc;
        handleResponse(responseData, _fuc);
        // if (!responseData.commonout) {
        //     this.$emit("returnRefreshTree", responseData.usergroupid);
        //     this.$message({
        //         message: '创建成功',
        //         type: 'success'
        //     });
        //     // const parent = node.parent;
        //     // const children = parent.data.children || parent.data;
        //     // const index = children.findIndex((d:any) => d.id === data.id);
        //     // data.id = responseData.roleid;
        //     // children.splice(index, 1, data);
        //     this.isNew = false;
        // } else {
        //     if (responseData.commonout.code == 103) {
        //         this.$message.error(responseData.commonout.errmsg);
        //         this.$emit("returnRefreshTree", item.rolepid);
        //     } else {
        //         this.$message.error(responseData.commonout.errmsg);
        //     }
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private updateRoleAPI(item: any) {
    let request: any = new RenameUserGroupReq();
    request.setCommonin(setCommon());
    request.setUsergroupid(item.id);
    request.setModifyname(item.label);
    authorClient.renameUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.isEdit = false;
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.$emit("returnRefreshTree", item.id);
            this.$message({
              message: "更新成功",
              type: "success",
            });
          } else {
            if (data.commonout.code == 103) {
              this.$message.error(data.commonout.errmsg);
              this.$emit("returnRefreshTree", item.id);
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
        } else {
          if (data.code == 0) {
            this.$emit("returnRefreshTree", item.id);
            this.$message({
              message: "更新成功",
              type: "success",
            });
          } else {
            if (data.code == 103) {
              this.$message.error(data.errmsg);
              this.$emit("returnRefreshTree", item.id);
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private deleteRoleAPIFuc(data: any, item: any) {
    this.$emit("returnRefreshTree", item.pid);
    this.$message({
      message: "删除成功",
      type: "success",
    });
    // if (node) {
    //     const parent = node.parent;
    //     const children = parent.data.children || parent.data;
    //     const index = children.findIndex((d:any) => d.id === data.id);
    //     children.splice(index, 1);
    // } else {
    //     this.$emit("returnRemoveNode", this.id);
    // }
  }
  private deleteRoleAPI(node: any, item: any) {
    let request: any = new DeleteUserGroupReq();
    request.setCommonin(setCommon());
    request.setUsergroupid(item.id);
    authorClient.deleteUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.$emit("returnRefreshTree", item.pid);
            this.$message({
              message: "删除成功",
              type: "success",
            });
            // if (node) {
            //     const parent = node.parent;
            //     const children = parent.data.children || parent.data;
            //     const index = children.findIndex((d:any) => d.id === data.id);
            //     children.splice(index, 1);
            // } else {
            //     this.$emit("returnRemoveNode", this.id);
            // }
          } else if (data.commonout.code == 100100 || data.commonout.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            this.$emit("returnRefreshTree", item.pid);
            this.$message({
              message: "删除成功",
              type: "success",
            });
            // if (node) {
            //     const parent = node.parent;
            //     const children = parent.data.children || parent.data;
            //     const index = children.findIndex((d:any) => d.id === data.id);
            //     children.splice(index, 1);
            // } else {
            //     this.$emit("returnRemoveNode", this.id);
            // }
          } else if (data.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private mainCheck() {
    if (this.compIsAddMainNode) {
      if (this.input) {
        this.createMainRoleAPI();
      } else {
        this.isEdit = false;
        this.$emit("returnRefreshTree");
      }
    } else {
      this.updateMainRoleAPI();
    }
  }

  private mainClose() {
    this.compEdit = false;
    if (this.isAddMainNode) {
      this.$emit("returnRemoveNode", this.id);
    }
  }

  private mainUpdate() {
    if (!this.isEdit) {
      this.compEdit = true;
      this.isEdit = true;
      if (!this.compIsAddMainNode) {
        this.input = this.compMainTitle;
      }
      this.$nextTick(() => {
        const ref: any = this.$refs.mainTitle;
        ref.focus();
      });
    }
  }

  private createMainRoleAPIFuc(data: any) {
    this.$emit("returnRefreshTree", data.usergroupid);
    this.$message({
      message: "创建成功",
      type: "success",
    });
    // this.compId = data.roleid;
    // this.compMainTitle = this.input;
    this.compEdit = false;
    this.compIsAddMainNode = false;
    // this.$emit("returnShowNewItem");
    this.$emit("returnIsMainEdit", "");
  }
  private createMainRoleAPI() {
    let request: any = new CreateUserGroupReq();
    request.setCommonin(setCommon());
    request.setName(this.input);
    request.setParentusergroupid(0);
    if (this.userGroupType === 1) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_INTERNAL);
    } else if (this.userGroupType === 2) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_OUTSOURCE);
    } else if (this.userGroupType === 3) {
      request.setExectype(ExecType.EXEC_TYPE_TEL_VERIFY);
    } else if (this.userGroupType === 4) {
      request.setExectype(ExecType.EXEC_TYPE_ROBOT);
    }else if (this.userGroupType === 6) {
      request.setExectype(ExecType.EXEC_TYPE_ADMIN);
    }else if (this.userGroupType === 7) {
      request.setExectype(ExecType.EXEC_TYPE_PHONE_SALE);
    }
    
    authorClient.createUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.isEdit = false;
        let _fuc = this.createMainRoleAPIFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //     this.$emit("returnRefreshTree", data.usergroupid);
        //     this.$message({
        //         message: '创建成功',
        //         type: 'success'
        //     });
        //     // this.compId = data.roleid;
        //     // this.compMainTitle = this.input;
        //     this.compEdit = false;
        //     this.compIsAddMainNode = false;
        //     // this.$emit("returnShowNewItem");
        //     this.$emit("returnIsMainEdit", "");
        // } else {
        //     if (data.commonout.code == 103) {
        //         this.$message.error(data.commonout.errmsg);
        //         this.$emit("returnRefreshTree");
        //         this.compIsAddMainNode = false;
        //         this.$emit("returnIsMainEdit", "");
        //     } else {
        //         this.$message.error(data.commonout.errmsg);
        //     }
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private updateMainRoleAPIFuc(data: any) {
    this.$message({
      message: "更新成功",
      type: "success",
    });
    // this.compId = data.roleid;
    // this.compMainTitle = this.input;
    this.compEdit = false;
  }
  private updateMainRoleAPI() {
    let request: any = new RenameUserGroupReq();
    request.setCommonin(setCommon());
    request.setUsergroupid(this.compId);
    request.setModifyname(this.input);
    authorClient.renameUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.isEdit = false;
        let _fuc = this.updateMainRoleAPIFuc;
        handleResponse(data, _fuc);
        if (data.commonout.code == 103) {
          this.compEdit = false;
          this.$message.error(data.commonout.errmsg);
          this.$emit("returnRefreshTree");
        }
        // if (!data.commonout || (data.commonout.code == 0)) {
        //     this.$message({
        //         message: '更新成功',
        //         type: 'success'
        //     });
        //     // this.compId = data.roleid;
        //     // this.compMainTitle = this.input;
        //     this.compEdit = false;
        // } else {
        //     if (data.commonout.code == 103) {
        //         this.compEdit = false;
        //         this.$message.error(data.commonout.errmsg);
        //         this.$emit("returnRefreshTree");
        //     } else {
        //         this.$message.error(data.commonout.errmsg);
        //     }
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
